// Display constants for the Accounts page; the accounts come from GET /api/admin/accounts

export const ACCOUNT_STAT_LABELS = [
  { key: "totalAccounts", label: "Total accounts" },
  { key: "freeActive", label: "Free active accounts" },
  { key: "awaitingActivation", label: "Awaiting activation" },
  { key: "activeFunded", label: "Active funded accounts" },
  { key: "breached", label: "Breached accounts" },
];

// Key order is the order options appear in the filters
export const ACCOUNT_STATUS = {
  active: { label: "Active", tone: "success", description: "Active funded account" },
  qualified: {
    label: "Qualified",
    tone: "success",
    description: "Hit the 1% target and we are awaiting payment",
  },
  awaiting: {
    label: "Awaiting Activation",
    tone: "warning",
    description: "Hit 1%, paid and done KYC; needs a new account synced",
  },
  breached: { label: "Breached", tone: "danger", description: "Breached a trading rule" },
  expired: {
    label: "Activation expired",
    tone: "neutral",
    description: "Hit 1% but the 48h activation window closed unpaid",
  },
  suspended: {
    label: "Suspended",
    tone: "danger",
    description: "Suspended pending a fraud / spam investigation",
  },
  closed: { label: "Closed", tone: "neutral", description: "Portal account closed down for fraud" },
  enrolled: { label: "Enrolled", tone: "neutral", description: "Enrolled free for a funded account" },
};

export const KYC_STATUS = {
  notStarted: { label: "Not Started", tone: "neutral" },
  pending: { label: "Pending", tone: "warning" },
  approved: { label: "Approved", tone: "success" },
  rejected: { label: "Rejected", tone: "danger" },
};

// Accounts with no withdrawal status yet show their progress percentage instead of a badge
export const WITHDRAWAL_STATUS = {
  eligible: { label: "Eligible", tone: "success" },
  notEligible: { label: "Not Eligible", tone: "danger" },
  payoutCap: { label: "Payout Cap Reached", tone: "warning" },
};

export const ACCOUNT_TYPES = { free: "Free", funded: "Funded" };

// users.status values the admin actions set, with how each is offered and confirmed
export const STATUS_ACTIONS = {
  suspended: {
    label: "Suspend account",
    confirm: "The trader loses access to the portal until the account is reactivated.",
  },
  deactivated: {
    label: "Close down account",
    confirm: "Closes the trader's portal account for fraud. They lose access until it's reactivated.",
  },
  active: { label: "Reactivate account", confirm: "The trader can log in to the portal again." },
};

// Payment and payout states from the API → tag tones
export const PAYMENT_TONES = { Paid: "success", Pending: "warning", Rejected: "danger" };
